import { Injectable } from '@angular/core';

// NGRX
import {Store} from '@ngrx/store';
import {AppState} from 'src/app/app.reducer';
import {FineModel} from 'src/app/store/fine.model';
import {SetFineAction} from 'src/app/store/fine.actions';

import {appConfig} from 'src/app/config/config';

@Injectable({
    providedIn: 'root'
})
export class PersistFineService {

    private nameSess: string;
    private data_fine: FineModel;

    constructor(private store: Store<AppState>) {
        this.nameSess = appConfig.data_session;
        this.loadData();
    }

    loadData() {
        if (localStorage.getItem(this.nameSess)) {
            this.data_fine = JSON.parse(atob(localStorage.getItem(this.nameSess)));
        } else {
            this.data_fine = new FineModel({
                rolAcceso: null,
                rolPermiso: null,
                acceso: null,
                cliente: '',
                contrato: '',
                fechaInicioContrato: {},
                fechaFinContrato: {},
                expedienteGesthispania: '',
                nombreOrganismo: '',
                codigoSancion: '',
                lugar: '',
                matricula: '',
                tipoInfraccion: '',
                estado: '',
                fechaFinEnlace: {},
                importeAPagar: null,
                importeBrutoConDescuento: null,
                isProcessingPay: null,
                comisionConDescuento: null,
                idEnlace: '',
                pagoActivo: false
            });
        }

        this.store.dispatch(new SetFineAction(this.data_fine));
        this.persistData(this.data_fine);
    }

    persistData(data_fine: FineModel) {
        this.data_fine = data_fine;
        let data_sess = btoa(JSON.stringify(this.data_fine));
        localStorage.setItem(this.nameSess, data_sess);
    }
}
